import { PageHeader } from "@shared/components/PageHeader";
import { Button } from "@shared/ui/button";
import { PlusIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ScheduleDashboard } from "../dashboard/dashboard";
import ScheduleList from "../list/list";

export default function ScheduleLanding() {
  const navigate = useNavigate();

  const handleCreateSchedule = () => {
    navigate("/mx/schedule/create");
  };

  return (
    <div className="p-2">
      <div className="flex justify-between items-center">
        <PageHeader
          title="Schedules"
          subtitle="Monitor and manage scheduled read cycles and their status."
        />
        <Button onClick={handleCreateSchedule}>
          <PlusIcon className="h-4 w-4 mr-2" />
          Create Schedule
        </Button>
      </div>
      <div className="mt-6">
        <ScheduleDashboard />
      </div>
      <div>
        <ScheduleList />
      </div>
    </div>
  );
}
